import { Dispatch, SetStateAction } from 'react';
import { ConsentError, ConsentsState, LinkBehavior } from './ConsentsList/ConsentsList.types';

export enum ConsentSectionType {
  Required = 'required',
  Optional = 'optional',
  AgreeToAll = 'agreeAll',
  Unified = 'unified',
  Atomic = 'atomic',
}

export type AnchorBehavior = 'newTab' | 'default';

export type ConsentsMapped = {
  [k: string]: LegalConsent[];
};

export type ConsentsLedger = {
  [k: string]: {
    [k: string]: boolean;
  };
};
export type ConsentHeader = {
  id: string;
  name: string;
  index: number;
  forCountries: string[] | null;
  excludeCountries: string[] | null;
  forOptions: string[] | null;
  excludeOptions: string[] | null;
  headerContainerClassName: string | null;
  headerContainerClassNameOverride: string | null;
  header: string | null;
  headerClassName: string | null;
  headerClassNameOverride: string | null;
  subHeader: string | null;
  subHeaderClassName: string | null;
  subHeaderClassNameOverride: string | null;
  description: string | null;
  descriptionClassName: string | null;
  descriptionClassNameOverride: string | null;
};

export type ConsentCheckbox = {
  id: string;
  category: string;
  name: string;
  index: number;
  forCountries: string[] | null;
  excludeCountries: string[] | null;
  forOptions: string[] | null;
  excludeOptions: string[] | null;
  isDisabled: boolean;
  defaultChecked: boolean;
  showCheckbox: boolean;
  checkboxLabelContainerClassName: string | null;
  checkboxLabelContainerClassNameOverride: string | null;
  checkboxContainerClassName: string | null;
  checkboxContainerClassNameOverride: string | null;
  checkboxClassName: string | null;
  checkboxClassNameOverride: string | null;
  title: string | null;
  titleClassName: string | null;
  titleClassNameOverride: string | null;
  label: {
    markdown: string;
  };
  labelClassName: string | null;
  labelClassNameOverride: string | null;
  termsLink: string | null;
  termsLinkLabel: string | null;
  termsLinkLabelClassName: string | null;
  termsLinkLabelClassNameOverride: string | null;
  termsLinkTarget: string | null;
  errorMessage: string | null;
  errorMessageClassName: string | null;
  errorMessageClassNameOverride: string | null;
  checked?: boolean;
};

export type LegalConsent = {
  hasError: boolean;
  id: string;
  name: string;
  countries: string[];
  options: string[];
  sectionType: string;
  index: number;
  showTopDivider: boolean;
  showBottomDivider: boolean;
  containerClassName: string | null;
  containerClassNameOverride: string | null;
  errorMessage: string | null;
  errorMessageClassName: string | null;
  errorMessageClassNameOverride: string | null;
  headers: ConsentHeader[];
  checkboxes: ConsentCheckbox[];
};

export interface OnConsentChangeParams {
  updatedConsentsState: ConsentsState;
}

export type OnConsentChange = (params: OnConsentChangeParams) => void;

export interface LegalConsentsProps {
  sessionId: string;
  consentsState: ConsentsState;
  setConsentsState: Dispatch<SetStateAction<ConsentsState>>;
  onConsentChange: (p: OnConsentChangeParams) => void;
  locale: string;
  version?: string;
  customLoader?: React.ReactNode;
  countryCode: string;
  option: string;
  isValidateErrors: boolean;
  isAuthorMode: boolean | null;
  anchorBehavior?: AnchorBehavior;
  linkBehavior?: LinkBehavior;
  onApiError?: () => JSX.Element;
  onModalClose?: () => void;
  onLoading?: (loading: boolean) => void;
}

export interface ToggleSelectedConsentCheckboxResponse {
  consents: LegalConsent[];
  selectedConsentsNames: string[];
  error: ConsentError;
}

// export interface SectionsList {
//   items: LegalConsent[];
//   gOpenInANewTabSuffix: string | null;
//   gOpenInAModalSuffix: string | null;
//   gOpenAccordionBtnLabel: string | null | null;
//   gCloseAccordionBtnLabel: string | null | null;
// }

export interface ConsentsItems {
  consentsList: LegalConsent[];
  gOpenInANewTabSuffix: string | null;
  gOpenInAModalSuffix: string | null;
  gOpenAccordionBtnLabel: string | null | null;
  gCloseAccordionBtnLabel: string | null | null;
}

export interface SectionsList {
  items: ConsentsItems[];
}

export interface AemData {
  data: {
    consentsSectionList: SectionsList;
  };
}

interface LegalConsentsByLocale {
  aemData: AemData;
}

interface Legal {
  legalConsentsByLocale: LegalConsentsByLocale;
}

interface Content {
  legal: Legal;
}

export type PhoenixLegalConsentsListType = {
  content: Content;
};

export interface LegalConsentsAuthorModeAndApiErrorHandlerProps {
  isAuthorMode: boolean;
  isApiError: boolean;
  onApiError?: () => JSX.Element;
}

// export type PhoenixLegalConsentsListType = {
//   sectionsList: {
//     items: LegalConsent[];
//   };
// };
